import { onlyDigits } from '@/lib/masks';

export interface EnderecoCep {
  logradouro: string;
  bairro: string;
  cidade: string;
  estado: string;
}

interface ViaCepResponse {
  logradouro?: string;
  bairro?: string;
  localidade?: string;
  uf?: string;
  erro?: boolean;
}

/**
 * Busca endereço a partir do CEP usando a API pública ViaCEP.
 * Retorna null para CEP inválido, inexistente ou falha de rede — nunca lança.
 */
export const buscarCep = async (cep: string): Promise<EnderecoCep | null> => {
  const digits = onlyDigits(cep);
  if (digits.length !== 8) return null;

  try {
    const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
    if (!response.ok) return null;

    const data: ViaCepResponse = await response.json();
    if (data.erro) return null;

    return {
      logradouro: data.logradouro ?? '',
      bairro: data.bairro ?? '',
      cidade: data.localidade ?? '',
      estado: (data.uf ?? '').toUpperCase(),
    };
  } catch {
    return null;
  }
};
